import { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { itemType } from "../../../../../utility/data";
import { additems, updateTransaction } from "../../../../../services/transaction";
import moment from "moment";
import { getLegacyServices } from "../../../../../services/legacy/legacyApi";
import { formatNumber } from "../../../../../utility/helper";

const CreateTransactionModal = ({ visible, singleTransactionData, actionTypes, fetchTransactionData, fetchFutureTransactionData, GetJournalData, GetLegaciesData, viewTransaction, onHide, SelectType, loading, setLoading, toast, assetName, GetAddedItemData }) => {
    const [legacyData, setLegacyData] = useState([]);
    // const InitialDateValue = viewTransaction?.transactions?.find((item) => item.is_initial)
    const accessToken = JSON.parse(localStorage.getItem('access_token'));

    const initialTransactionData = {
        date: moment().toDate(),
        itemName: '',
        itemType: itemType.length > 0 ? itemType[0].value : '',
        purchasePrice: '',
        legacy: legacyData.length > 0 ? legacyData[0] : '',
    };
    const [createTransactionData, setCreateTransactionData] = useState(initialTransactionData);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        GetLegacyAllData();
    }, []);

    useEffect(() => {
        if (legacyData.length > 0 || itemType.length > 0) {
            setCreateTransactionData((prevData) => ({
                ...prevData,
                itemType: itemType.length > 0 ? itemType[0].value : prevData.itemType,
                legacy: legacyData.length > 0 ? legacyData[0] : prevData.legacy,
            }));
        }
    }, [legacyData, itemType]);



    const GetLegacyAllData = async () => {
        // setLoading(true);
        try {
            const response = await getLegacyServices(accessToken);
            if (response.status === 200) {
                const data = response?.data.data;
                setLegacyData(data);
            } else {
                throw new Error('Failed to fetch user data');
            }
        } catch (err) {
            console.log(err.message || 'An error occurred');
        } finally {
            // setLoading(false);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target || e;

        setCreateTransactionData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        if (errors[name] && value && value.toString().trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };


    const validateForm = () => {
        const newErrors = {};

        if (!createTransactionData.date) {
            newErrors.date = "Date is required";
        }
        if (!createTransactionData.purchasePrice) {
            newErrors.purchasePrice = "Purchase Price is required";
        }

        if (!createTransactionData.itemName) {
            newErrors.itemName = "Item Name is required";
        }
        if (!createTransactionData.itemType) {
            newErrors.itemType = "Item Name is required";
        }
        if (!createTransactionData.legacy) {
            newErrors.legacy = "legacy is required";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handlePurchasePriceChange = (e) => {
        const { name } = e.target;
        let value = e.target.value;

        let rawValue = value.replace(/[^0-9.-]/g, '');

        const decimalCount = (rawValue.match(/\./g) || []).length;
        if (decimalCount > 1) {
            return;
        }

        value = formatNumber(rawValue);

        let AutoCalPL = null;
        AutoCalPL = formatNumber(Number(rawValue));


        setCreateTransactionData((prevData) => ({
            ...prevData,
            value: value,
            ...(AutoCalPL !== null && { purchasePrice: AutoCalPL })
        }));

        if (errors[name] && value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };


    const handleSave = async () => {
        if (validateForm()) {
            setLoading(true);
            if (!assetName) {
                setLoading(false);
                toast.current.show({
                    className: 'bg-yellow-700 text-white',
                    severity: 'warn',
                    summary: 'Warning',
                    detail: "Please add the first initial transaction",
                    life: 3000,
                });
                return;
            }

            const formattedData = {
                ...createTransactionData,
                date: createTransactionData.date
                    ? moment(createTransactionData.date).format('YYYY-MM-DD HH:mm:ss')
                    : null,
                purchasePrice: createTransactionData.purchasePrice ? createTransactionData.purchasePrice.replace(/[,']/g, '') : '',
            };

            try {
                const response = await (actionTypes === "Create"
                    ? additems(formattedData, assetName, accessToken)
                    : "");
                if (response.data.status === true) {
                    fetchTransactionData();
                    GetAddedItemData();
                    // fetchFutureTransactionData();
                    GetJournalData();
                    GetLegaciesData();
                    handleClose();
                    toast.current.show({
                        className: 'bg-green-300 text-white',
                        severity: 'success',
                        summary: 'Success',
                        detail: response.data.message,
                        life: 3000,
                    });
                }
            } catch (error) {
                console.error('Error adding transaction:', error);
                toast.current.show({
                    className: 'bg-yellow-700 text-white',
                    severity: 'warn',
                    summary: 'Warning',
                    detail: error.message,
                    life: 3000,
                });
            } finally {
                setLoading(false);
            }
        }
    };

    if (!visible) return null;

    const handleClose = () => {
        setCreateTransactionData(initialTransactionData);
        setErrors({});
        onHide();
    };

    return (
        <div>
            <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50">
                <div className="bg-[rgba(44,52,79,1)] md:w-1/2 w-1/2 shadow-lg p-6 text-[rgba(255,255,255,1)]">
                    <div className="flex items-center justify-between mb-3">
                        <h2 className="text-2xl">Add Item</h2>
                        <FaTimes onClick={handleClose} className="cursor-pointer" fontSize={26} />
                    </div>
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
                        <div className="col-span-1 flex items-center gap-5 mb-4">
                            <label className="text-sm font-medium text-white w-1/4">Item Type</label>
                            <Dropdown
                                value={createTransactionData.itemType}
                                name="itemType"
                                onChange={(e) => handleInputChange({ name: "itemType", value: e.value })}
                                options={itemType}
                                optionLabel="name"
                                placeholder="Select item type"
                                className={`rounded-lg w-full p-0 bg-transparent border border-gray-300 text-white focus:outline-none focus:border-b-2 ${createTransactionData.itemType ? "asset_Dropdown" : ""}`}
                            />
                        </div>
                        <div className="flex flex-col">
                            <div className="col-span-1 flex items-center gap-5 mb-4">
                                <label className="text-sm font-medium text-white w-1/4">Legacy*</label>
                                <Dropdown
                                    value={createTransactionData.legacy}
                                    name="legacy"
                                    onChange={(e) => handleInputChange({ name: "legacy", value: e.value })}
                                    options={legacyData}
                                    placeholder="Select legacy"
                                    optionLabel="name"
                                    className={`w-full p-0 bg-transparent border border-gray-300 text-white rounded-lg focus:outline-none focus:border-b-2 ${createTransactionData.legacy ? "asset_Dropdown" : ""}`}
                                />
                            </div>
                            {errors.legacy && <small className="text-red-500 text-center mt-[-10px]">{errors.legacy}</small>}
                        </div>
                        <div className="flex flex-col">
                            <div className="col-span-1 flex items-center gap-5 mb-4">
                                <label className="text-sm font-medium text-white w-1/4">Name*</label>
                                <input
                                    type="text"
                                    name="itemName"
                                    value={createTransactionData.itemName}
                                    onChange={handleInputChange}
                                    autoComplete="off"
                                    className="block w-full bg-transparent border-b disabled:text-gray-500 border-gray-300 text-white focus:outline-none focus:border-b-2"
                                />
                            </div>
                            {errors.itemName && <small className="text-red-500 text-center mt-[-10px]">{errors.itemName}</small>}
                        </div>
                        <div className="flex flex-col">
                            <div className="col-span-1 flex items-center gap-5 mb-4">
                                <label className="text-sm font-medium text-white w-1/4">Date*</label>
                                <Calendar
                                    value={createTransactionData.date}
                                    onChange={(e) => handleInputChange({ name: "date", value: e.value })}
                                    dateFormat="dd/mm/yy"
                                    className="asset_date w-full"
                                    maxDate={moment().toDate()}
                                    disabled={actionTypes === "Update"}
                                />

                            </div>
                            {errors.date && <small className="text-red-500 text-center mt-[-10px]">{errors.date}</small>}
                        </div>
                        <div className="flex flex-col">
                            <div className="col-span-1 flex items-center gap-5 mb-4">
                                <label className="text-sm font-medium text-white w-1/4">Purchase Price*</label>
                                <input
                                    type="text"
                                    name="type"
                                    value={createTransactionData.purchasePrice}
                                    onChange={handlePurchasePriceChange}
                                    autoComplete="off"
                                    className="block w-full bg-transparent border-b disabled:text-gray-500 border-gray-300 text-white focus:outline-none focus:border-b-2"
                                />
                            </div>
                            {errors.purchasePrice && <small className="text-red-500 text-center mt-[-10px]">{errors.purchasePrice}</small>}
                        </div>
                    </div>

                    <div className="mt-4 flex gap-2">
                        <button
                            disabled={loading}
                            onClick={handleSave}
                            className={`bg-secondary text-primary px-4 py-2 rounded ${loading ? 'bg-gray-600 opacity-50 cursor-not-allowed' : ''}`}
                        >
                            {loading ? 'Saving...' : actionTypes === "Create" ? 'Save' : 'Update'}
                        </button>
                        <button
                            onClick={handleClose}
                            className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CreateTransactionModal;
